let initialReducer = {
    
}

let AccountReducers = (state = initialReducer, action) => {
    switch (action.type) {
        case "LOADER":
            return {
                loader: action.payload
            };
        default:
            return state;
    }
}

export default AccountReducers